// Logger condicionado por la variable de entorno REACT_APP_DEBUG_LOGS.
// Permite habilitar/deshabilitar los logs de depuracion en consola
// independientemente de si el build es de produccion o staging.
//
// Activar:    REACT_APP_DEBUG_LOGS=true  (en .env o inline en el script)
// Desactivar: cualquier otro valor / vacio
//
// Uso:
//   import debug from 'utils/debugLog';
//   debug.log('algo', data);
//   debug.warn('cuidado');

const DEBUG_LOGS = (process.env.REACT_APP_DEBUG_LOGS || '').trim() === 'true';

const noop = () => {};

const debug = {
  enabled: DEBUG_LOGS,
  log: DEBUG_LOGS ? console.log.bind(console) : noop,
  warn: DEBUG_LOGS ? console.warn.bind(console) : noop,
  info: DEBUG_LOGS ? console.info.bind(console) : noop,
  // Los errores reales se dejan siempre visibles.
  error: console.error.bind(console),
};

export default debug;
